<div class="cardContainer">
    <div class="cardBody">
        <ng-content></ng-content>
    </div>
</div>